import { render, staticRenderFns } from "./LayoutManager.vue?vue&type=template&id=31310dd2&scoped=true"
import script from "./LayoutManager.vue?vue&type=script&lang=js"
export * from "./LayoutManager.vue?vue&type=script&lang=js"
import style0 from "./LayoutManager.vue?vue&type=style&index=0&id=31310dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31310dd2",
  null
  
)

export default component.exports